import { render, staticRenderFns } from "./fieldCollection.vue?vue&type=template&id=4f31968f&scoped=true&"
import script from "./fieldCollection.vue?vue&type=script&lang=js&"
export * from "./fieldCollection.vue?vue&type=script&lang=js&"
import style0 from "./fieldCollection.vue?vue&type=style&index=0&id=4f31968f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31968f",
  null
  
)

export default component.exports